import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Logo } from "./Logo";
import { whatsappUrl } from "../../data";

const NAV = [
  { label: "La experiencia", href: "#experiencia" },
  { label: "Itinerario", href: "#itinerario" },
  { label: "Galería", href: "#galeria" },
  { label: "Precio", href: "#precio" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 2, duration: 0.8, ease: [0.65, 0, 0.35, 1] }}
      className={`fixed top-0 left-0 w-full z-[60] transition-colors duration-500 ${
        scrolled ? "bg-ink/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="shrink-0">
          <Logo imgClass="h-9 sm:h-11" />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.href.slice(1)}`}
              className="link-underline font-body text-sm text-[var(--paper)]/80 hover:text-[var(--paper)] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta"
            className="btn-glacier hidden sm:inline-flex items-center gap-2 border border-glacier/60 px-5 py-2.5 text-xs uppercase tracking-[0.2em] font-body font-semibold text-glacier hover:text-ink transition-colors duration-300"
            style={{ borderColor: "var(--glacier)" }}
          >
            Reserva tu plaza
          </a>
          <button
            data-testid="menu-toggle"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menú"
            className="md:hidden flex flex-col gap-1.5 p-2"
          >
            <span className={`h-px w-6 bg-white transition-transform ${open ? "translate-y-[6px] rotate-45" : ""}`} />
            <span className={`h-px w-6 bg-white transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`h-px w-6 bg-white transition-transform ${open ? "-translate-y-[6px] -rotate-45" : ""}`} />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.65, 0, 0.35, 1] }}
            className="md:hidden overflow-hidden bg-ink/95 backdrop-blur-xl border-t border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${n.href.slice(1)}`}
                  className="font-display text-3xl text-[var(--paper)]"
                >
                  {n.label}
                </a>
              ))}
              <a
                href={whatsappUrl()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setOpen(false)}
                data-testid="mobile-cta"
                className="mt-2 inline-flex items-center justify-center bg-glacier text-ink px-6 py-4 text-xs uppercase tracking-[0.2em] font-body font-bold"
                style={{ backgroundColor: "var(--glacier)", color: "var(--ink)" }}
              >
                Reserva tu plaza
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
